import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import HeroSection from '../components/home/HeroSection';
import RecentJobs from '../components/home/RecentJobs';
import Categories from '../components/home/Categories';
import PopularCategories from '../components/home/PopularCategories';
import RecentBlogs from '../components/home/RecentBlogs';
import OrganizationSchema from '../components/seo/OrganizationSchema';
import { setDefaultSEO } from '../utils/seoUtils';
import { AdUnitJobs } from '../components/adsense';
// Comment out or create these components if needed
// import BlogPosts from '../components/home/BlogPosts';
// import EmployerCTA from '../components/home/EmployerCTA';
import './Home.css';

function Home() {
  const [filters, setFilters] = useState({
    category: [],
    jobType: [],
    location: [],
    experience: []
  });

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  // Set default SEO for home page
  useEffect(() => {
    setDefaultSEO('Home');
  }, []);

  return (
    <div className="home">
      {/* SEO Components */}
      <OrganizationSchema />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        
      >
      
      <HeroSection />   
      <Categories />
      
      {/* Ad After Categories */}
      <AdUnitJobs />
      
      <RecentBlogs />
      <PopularCategories onFilterChange={handleFilterChange} />
      
      {/* Ad Before Recent Jobs */}
      <AdUnitJobs />
      
      <RecentJobs />
        
      </motion.div>
     
    </div>
  );
}

export default Home;